import styled from '@emotion/styled';

export const ImpactPlaceholderContainer = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
